import { Locker } from "./LockerDataTypes";

export enum FilterType{
    posOnly = "posOnly"
}

export interface FilterStrategy{
    name: FilterType,
    implementation: IFilter;
}

export interface IFilter {
    value: any;
    IsApplicable: () => boolean;
    Run: (lockers: Locker[]) => Locker[];
    Clear: () => void
}